var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAggiungi = function SvgAggiungi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-remove-circle-outline",
    "data-name": "Icon ionic-ios-remove-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    d: "M50,7.16A42.63,42.63,0,1,1,19.71,19.7,42.85,42.85,0,0,1,50,7.16M50,.5A49.5,49.5,0,1,0,99.5,50,49.5,49.5,0,0,0,50,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.43,46.72H53.7V28A3.69,3.69,0,0,0,50.29,24H50a3.74,3.74,0,0,0-3.72,3.74c0,.07,0,.15,0,.22V46.72H27.53a3.69,3.69,0,0,0-4,3.41c0,.1,0,.21,0,.31a3.74,3.74,0,0,0,3.74,3.72h19V72.88a3.72,3.72,0,1,0,7.43,0V54.15H72.43a3.72,3.72,0,1,0,0-7.43Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAggiungi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/aggiungi.f70ffc15.svg";
export { ForwardRef as ReactComponent };